import React, {useState} from "react";
import { NavLink } from "react-router-dom"
import "./header.css"

import { GiHamburgerMenu } from "react-icons/gi";

const Header = () => {
    const [show, setShow] = useState(false);

  const handleNavbarDisplay = () => {
    setShow(!show);
  };
    return (
        <>
         <nav className="navbar">
    
        <NavLink to="/"> <h2>Ice Cream Creations</h2></NavLink>
            <ul>

            <li>
            <NavLink to='/'>Home</NavLink>
            </li>

            <li>
            <NavLink to='/menuPage'>Menu</NavLink>
            </li>

            <li>
            <NavLink to='/booking'>Book an Event</NavLink>
            </li>

            <li>
            <NavLink id='buttonHeader' to='/contact' >Contact</NavLink>
            </li>

            </ul>

            <GiHamburgerMenu
          onClick={() => handleNavbarDisplay()}
          size={20}
          className="navbarIcon"
        />
        
        </nav>

      {show && (
        <section className="navbarMobile">
           <ul>

<li>
<NavLink to='/' id="companyName">Home</NavLink>
</li>

<li>
<NavLink to='/menuPage'>Menu</NavLink>
</li>

<li>
<NavLink to='/booking'>Book an Event</NavLink>
</li>

<li>
<NavLink  to='/contact' >Contact</NavLink>
</li>

</ul>
        </section>
      )}
    </>

    )
}

export default Header